// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}

.dx-table-wrapper-container {
  width: 100%;
}

.action-list {
  display: flex;
  flex-direction: column;
}

.action-item:hover {
  background-color: #f5f5f5;
}

:host ::ng-deep .dx-datagrid-headers .dx-header-row > td {
  font-size: 11px !important;
  font-weight: bold;
  vertical-align: middle !important;
  position: relative !important;
  padding: 10px 5px !important;
  /* Revert to standard table-cell layout to fix "destroyed" grid */
  display: table-cell !important;
}
:host ::ng-deep .dx-datagrid-headers .dx-header-row > td .dx-column-indicators {
  display: inline-block !important;
  vertical-align: middle !important;
  cursor: pointer;
  margin-left: 5px !important;
  float: none !important;
}
:host ::ng-deep .dx-datagrid-headers .dx-header-row > td .dx-sort, :host ::ng-deep .dx-datagrid-headers .dx-header-row > td .dx-header-filter {
  display: inline-block !important;
  margin-top: 0 !important;
  float: none !important;
}
:host ::ng-deep .dx-datagrid-headers .dx-header-row > td .dx-datagrid-text-content {
  white-space: normal !important;
  text-overflow: clip !important;
  overflow: visible !important;
  display: inline-block !important;
  vertical-align: middle !important;
  width: auto !important;
  color: #333 !important;
}
.dark-theme :host ::ng-deep .dx-datagrid-headers .dx-header-row > td .dx-datagrid-text-content {
  color: #fff !important;
}
:host ::ng-deep .dx-datagrid-rowsview .dx-row > td {
  font-size: 14px !important;
  height: 30px !important;
  padding: 10px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/core/fp-dx-datagrid/fp-dx-datagrid.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAGE;EACE,0BAAA;EACA,iBAAA;EACA,iCAAA;EACA,6BAAA;EACA,4BAAA;EAEA,iEAAA;EACA,8BAAA;AADJ;AAGI;EACE,gCAAA;EACA,iCAAA;EACA,eAAA;EACA,2BAAA;EACA,sBAAA;AADN;AAII;EACE,gCAAA;EACA,wBAAA;EACA,sBAAA;AAFN;AAKI;EACI,8BAAA;EACA,8BAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,sBAAA;EACA,sBAAA;AAHR;AAOQ;EACI,sBAAA;AALZ;AAUE;EACE,0BAAA;EACA,uBAAA;EACA,wBAAA;AARJ","sourcesContent":[":host {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.dx-table-wrapper-container {\r\n  width: 100%;\r\n}\r\n\r\n.action-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.action-item:hover {\r\n  background-color: #f5f5f5;\r\n}\r\n\r\n:host ::ng-deep {\r\n  .dx-datagrid-headers .dx-header-row > td {\r\n    font-size: 11px !important; \r\n    font-weight: bold;\r\n    vertical-align: middle !important;    \r\n    position: relative !important;\r\n    padding: 10px 5px !important;\r\n    \r\n    /* Revert to standard table-cell layout to fix \"destroyed\" grid */\r\n    display: table-cell !important;\r\n    \r\n    .dx-column-indicators {\r\n      display: inline-block !important;\r\n      vertical-align: middle !important;\r\n      cursor: pointer;\r\n      margin-left: 5px !important;\r\n      float: none !important;\r\n    }\r\n\r\n    .dx-sort, .dx-header-filter {\r\n      display: inline-block !important;\r\n      margin-top: 0 !important;\r\n      float: none !important;\r\n    }\r\n\r\n    .dx-datagrid-text-content { \r\n        white-space: normal !important;\r\n        text-overflow: clip !important; \r\n        overflow: visible !important;\r\n        display: inline-block !important; \r\n        vertical-align: middle !important;\r\n        width: auto !important;\r\n        color: #333 !important;\r\n    }\r\n\r\n    .dark-theme & {\r\n        .dx-datagrid-text-content {\r\n            color: #fff !important;\r\n        }\r\n    }\r\n  }\r\n\r\n  .dx-datagrid-rowsview .dx-row > td {\r\n    font-size: 14px !important;\r\n    height: 30px !important;\r\n    padding: 10px !important; \r\n    \r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
